<h2>EDIZIONE 2015 (ECC Awareness Contest)</h2>
<p>
	Il CryptoLabTN (Laboratory of Industrial Mathematics and Cryptography at University of Trento),
	in collaborazione con Clusit (The Italian Association for Computer Security), ha organizzato l'
	"ECC Awareness Contest".
	L'evento è organizzato nell'ambito del mese europeo della sicurezza informatica (ECSM) e si
	rivolge agli studenti con nozioni di programmazione. Il nostro concorso mira a sensibilizzare
	sul fatto che gli algoritmi crittografici invecchiano e dovrebbero essere continuamente testati,
	mantenuti, migliorati (che è ciò che i crittografi, tra le altre cose, fanno).
</p>
<hr>
<div id="programmaGenerale">
	<h3>Programma generale</h3>
	<ul>
		<li>Lunedì 19 ottobre alle ore 12:00 (ora di Trento) abbiamo pubblicato un set di
			<a href="https://en.wikipedia.org/wiki/Elliptic_curve_cryptography">chiavi pubbliche</a> per ECC.
		<li>I partecipanti hanno avuto tempo fino a venerdì 23 ottobre alle 17:00 per rompere
			queste chiavi (ovvero trovare le rispettive chiavi private) e inviare i loro risultati.</li>
		<li>I partecipanti sono stati classificati in base al numero di chiavi rotte
			e all'ora dell'ultima submission.</li>
		<li>I premi vengono assegnati ai primi tre gruppi classificati.</li>
	</ul>
</div>
<hr>
<div id="news">
	<h3>News</h3>
	<ul>
		<li>[2015/11/09] Abbiamo aggiornato la sezione Feedback dove descriviamo come abbiamo progettato
			il concorso, inoltre abbiamo pubblicato alcuni feedback che abbiamo ricevuto dai partecipanti. </li>
		<li> [2015/10/27] <strong>La classifica finale è pubblica!</strong> </li>
		<li> [2015/10/23, 17:00] <font color=red>Il contest è concluso!</font> Grazie per la partecipazione!
			Le statistiche finali e la classifica sono già pubbliche. </li>
		<li> [2015/10/19] È iniziato il contest! Controlla le istruzioni per scaricare il materiale di lavoro.
			<strong>Abbiamo aggiornato le istruzioni per l'invio delle soluzioni</strong>.
		</li>
		<li> [2015/10/18] Il formato del materiale del concorso è stato leggermente modificato
			(sono stati aggiunti degli spazi vuoti dopo i numeri che descrivono i punti razionali),
			controllare il file campione.</li>
		<li> [2015/10/16] Le istruzioni sono state aggiornate con maggiori dettagli ed è disponibile
			un file campione per testare i tuoi strumenti e prepararti per la gara. Inoltre sono
			stati definiti i premi! Controlla la sezione appropriata.</li>
		<li> [2015/09/28] È stata creata una mail di contatto per il concorso! Puoi scriverci all'indirizzo
			<a href="mailto:contest.cryptolabtn@gmail.com">contest.cryptolabtn&#64;gmail.com</a>
		</li>
	</ul>
</div>
<hr>
<div id="contest">
	<h3>Contest</h3>
	<p>
		Abbiamo pubblicato un set di chiavi pubbliche ECC. Un partecipante deve trovare la
		chiave privata corrispondente di ciascuna chiave pubblica risolvendo un ECDLP
		(Elliptic Curve Discrete Logarithm Problem).
	</p>
</div>
<hr>
<div id="materiale">
	<h3>Materiale</h3>
	<p>
		Fare clic sui link seguenti per scaricare il <a href="../../../../assets/
			attivita/cryptowars/2015contest.publicKeys.txt">materiale del contest</a>.
		Le soluzioni sono ora <a href="../../../../assets/attivita/cryptowars/
			2015contest.solution.txt">disponibili</a>.</p>
	<p>
		Forniamo un <a href="../../../../assets/attivita/cryptowars/2015example.publicKeys.txt">
			file campione</a> (con due semplici chiavi per attaccare), insieme a una
		<a href="../../../../assets/attivita/cryptowars/2015example.solution.txt">
			soluzione corrispondente</a>, nel formato che dovrebbe essere
		utilizzato per inviare i risultati.
	</p>
	<p>Il formato per il materiale del concorso è un file di testo. Ogni chiave
		pubblica è rappresentata da 5 righe ed è separata dalla successiva da una riga vuota.</p>
	<ul>
		<li> La prima riga contiene un contatore che identifica la chiave pubblica
			<img src="https://latex.codecogs.com/gif.latex?\large&amp;space;(1, 2, 3, ...)." />
		</li>
		<li>La seconda riga contiene un numero primo p che è la cardinalità del campo base.</li>
		<li>La terza riga contiene due elementi di <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;\mathbb{F}_p:A,B" /> che descrivono una curva
			ellittica <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;E" /> della forma <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;y^2=x^3+A\cdot x+B" />, definita su <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;\mathbb{F}_p" />.</li>
		<li>La quarta linea rappresenta un punto razionale <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;P" /> di <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;E" /> tramite le sue coordinate <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;(X,Y)" />.</li>
		<li>Infine la quinta riga descrive la vera chiave pubblica, cioè un punto razionale
			<img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;Q" /> di <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;E" /> che è un multiplo di <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;P" /> (<img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;Q=kP" /> per qualche <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;k" />)
		</li>
	</ul>
	<p>
		I partecipanti sono tenuti a trovare l'intero <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;k" /> per ogni chiave pubblica data.
	</p>
	<p>
		<em>Avviso per gli utenti Windows:</em> Se apri i file (cioè in blocco note) potresti
		vedere tutto su una singola riga. Non dovrebbe essere troppo difficile elaborarli
		manualmente o automaticamente per avere ogni chiave pubblica nel formato appropriato.
	</p>
	<hr>
	<h3>Invio delle risposte</h3>
	<p> Un partecipante è identificato da un indirizzo e-mail univoco.
		Un partecipante può presentare una o più soluzioni al concorso su
		in qualsiasi momento tra la pubblicazione del Materiale del Concorso e la fine
		del contest, che è fissato venerdì 23 ottobre alle 17:00.
	</p>
	<p> Invii una soluzione per la gara inviando una mail a
		<a href="mailto:contest.cryptolabtn@gmail.com">contest.cryptolabtn&#64;gmail.com</a>.
	</p>
	<p>
		Un invio può consistere in una o più soluzioni.
		Sono consentiti invii multipli ma saranno considerati validi solo i primi tre invii per ogni
		chiave pubblica. Ulteriori invii verranno scartati. Il formato per l'invio è un file di testo.
		Ogni riga deve rappresentare una soluzione per una singola chiave pubblica e quindi contenere due numeri
		scritti in base decimale e separati da uno spazio: un contatore che identifica la chiave
		pubblica <img src="https://latex.codecogs.com/gif.latex?\large&amp;space;(1, 2, 3, ...)" />
		e la corrispondente chiave privata.
	</p>
</div>
<hr>
<div id="coding">
	<h3>Coding</h3>
	<p><i>Devo scrivere un mio programma per trovare le soluzioni? La risposta breve è: no, ma sì. </i></p>
	<p>
		La risposta lunga è: non abbiamo modo di verificare se hai scritto del codice tuo per risolvere i problemi
		del nostro concorso (non ti chiediamo di mostrare il codice e puoi lavorare con il linguaggio di
		programmazione che preferisci). E probabilmente sarà più facile cercare qualche programma già esistente
		che faccia tutto il lavoro. Ma il punto centrale di questo concorso è sfidare te stesso a comprendere
		un problema crittografico, cercare soluzioni possibili, scrivere codice che implementa le soluzioni
		e cercare di renderlo sempre più efficiente.
	</p>
	<br>
	<p><i> Devo creare i miei algoritmi per trovare le soluzioni? Assolutamente no! </i></p>
	<p>Ci sono tonnellate di buoni algoritmi che potrebbero rompere chiavi corte o deboli.
		Guardati intorno e trova un algoritmo che sei in grado di capire. Quindi prova a
		implementarlo. Questa sembra già una buona strategia per divertirsi al concorso.
	</p>
</div>
<hr>
<div id="framework">
	<h3>Framework</h3>
	<p class="lead">Che cos'è l'ECDLP?</p>
	<p>
		Data una curva ellittica <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;E" /> definita su un campo finito <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;\mathbb{F}_q" />, un punto <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;P\in E(\mathbb{F}_q)" /> di ordine <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;n" /> ed un punto <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;Q=kP" />, dove <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;1\leq k \leq n-1," /> l'ECDLP consiste nel determinare
		<img src="https://latex.codecogs.com/gif.latex?\large&amp;space;k" />. Il Punto
		<img src="https://latex.codecogs.com/gif.latex?\large&amp;space;Q" /> è detto chiave pubblica,
		mentre <img src="https://latex.codecogs.com/gif.latex?\large&amp;space;k" /> è detto chiave
		privata. Una soluzione per una singola chiave pubblica <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;Q" /> consiste quindi nell'intero <img src="https://latex.codecogs.com/gif.latex?\
			large&amp;space;k" /> tale che <img src="https://latex.codecogs.com/gif.latex?\large&amp;space;kP=Q" />.
	</p>
	<p class="lead">Perchè siamo interessati all'ECDLP</p>
	<p>
		L'intrattabilità computazionale del problema del logaritmo discreto delle curve
		ellittiche è alla base della maggior parte della crittografia basata su curve ellittiche.
		Un esempio di crittografia ECC è l'Elliptic Curve Digital Signature Algorithm (ECDSA),
		un algoritmo per la firma digitale. Offre una variante applicata alle curve ellittiche
		del Digital Signature Algorithm (DSA) e la sua sicurezza si basa sulla difficoltà dell'ECDLP
		sotto certe ipotesi. Gli schemi di firma digitale sono progettati per fornire la controparte
		digitale alle firme scritte a mano. La firma digitale è un numero dipendente da un segreto
		noto solo al firmatario, la chiave privata del firmatario, ma tutti sono comunque in grado
		di controllare la firma utilizzando dati pubblici: la chiave pubblica del firmatario.
	</p>
	<p>Rimandiamo a Wikipedia per una visione più dettagliata di ECDSA.</p>
	<p>Il materiale del concorso è un insieme di chiavi pubbliche ECC. Non ti
		forniremo messaggi crittografati da decifrare.</p>
</div>
<hr>
<div id="classificaFinale">
	<!-- Ranking -->
	<h3>Classifica finale</h3>
	<p>
		La graduatoria tra i partecipanti viene effettuata considerando queste
		due semplici regole:
	</p>
	<ol>
		<li>Un partecipante si classifica più in alto di un altro partecipante se ha falsificato più firme.</li>
		<li>Un partecipante si classifica più in alto di un altro partecipante con lo stesso numero di firme
			contraffatte
			se il loro ultimo invio valido è stato effettuato in anticipo.</li>
	</ol>
	<table class="table">
		<thead>
			<tr class="header">
				<th style="text-align: center"> Rk </th>
				<th style="text-align: center"> Partecipanti </th>
				<th style="text-align: center"> Ora dell'ultima soluzione inviata</th>
				<th style="text-align: center"> Firme valide </th>
			</tr>
		</thead>
		<tbody>

			<tr class="odd" style="background-color: LIGHTYELLOW">
				<td align="center">1</td>
				<td align="center"> Crypto Terroni Team(*) * </td>
				<td align="center"> 2015/10/22 19:19 </td>
				<td align="center"> 20 </td>
			</tr>
			<tr class="even" style="background-color: WHITESMOKE">
				<td align="center">2</td>
				<td align="center"> Luca Chiodini </td>
				<td align="center"> 2015/10/21 21:24 </td>
				<td align="center"> 14 </td>
			</tr>
			<tr class="odd" style="background-color: ANTIQUEWHITE">
				<td align="center">3</td>
				<td align="center"> Lorenzo Cameroni - Alessandro De Piccoli </td>
				<td align="center"> 2015/10/23 16:32 </td>
				<td align="center"> 14 </td>
			</tr>
			<tr class="even">
				<td align="center">4</td>
				<td align="center"> Anomalous Marty with Delorean </td>
				<td align="center"> 1985/10/21 15:26 </td>
				<td align="center"> 1 </td>
			</tr>
		</tbody>
	</table>
	<p> Notes: <br>
		*: Gruppo formato da Giuseppe Vitto, Carmine Abate, Giuseppe Cotardo.<br>
	</p>
</div>
<hr>
<div id="statistiche">
	<h3>Statistiche</h3>
	<ul>
		<li>Gruppi partecipanti: 4</li>
		<li>Submissions: 32</li>
		<li>Chiavi rotte: 20</li>
		<li>Chiavi non rotte: 0</li>
	</ul>
</div>
<hr>
<div id="premi">
	<!-- Premi -->
	<h3>Premi</h3>
	<p>
		Il vero premio che ottieni partecipando a questo concorso è divertirti
		imparando e facendo le cose da solo!
	</p>
	<p>
		Al vincitore vien assegnata l'iscrizione gratuita a <a href="http://www.clusit.it/">Clusit</a>.
		Coloro che si classificano nelle prime tre posizioni sono invitati a partecipare (gratuitamente)
		a tutti gli eventi che il CryptoLabTN ospiterà durante tutto il 2015 e il 2016.
		Inoltre li invitiamo a pranzo il giorno della premiazione.
	</p>
	<p>
		I premi sono assegnati durante uno degli eventi
		organizzati presso l'Università di Trento, nei giorni successivi alla gara.
	</p>
</div>
<hr>
<div id="ratio">
	<!-- Ranking -->
	<h3> Come abbiamo pensato il contest? </h3>
	<p>
		Abbiamo utilizzato il software Magma per generare molte curve con parametri
		casuali e poi le abbiamo selezionate in base a vari parametri come volevamo:
	</p>
	<ul>
		<li> Alcune curve con parametri apparentemente sicuri (ad esempio un grande
			campo primo, un ampio insieme di punti razionali, ecc.) ma in realtà non sicuri.</li>
		<li>Qualche curva debole che è più forte di come sembra.</li>
		<li>Alcune curve medie.</li>
	</ul>
	<p>
		In questa luce, il trucco principale utilizzato per scegliere le curve è stato
		quello di fattorizzare l'ordine dei generatori di curve ellittiche. Infatti, le
		curve definite su grandi campi primi il cui ordine del generatore fattorizza in
		molti numeri primi sono molto vulnerabili all'attacco Pollard-Rho. D'altra parte,
		se l'ordine è primo, questa vulnerabilità non esiste e quindi una curva definita
		su un campo primo più piccolo potrebbe effettivamente essere più sicura di curve
		definite su campi primi più grandi. Inoltre, abbiamo proceduto a testare ogni
		curva con l'algoritmo del logaritmo discreto di Magma (che implementa Pollard-Rho
		e varie ottimizzazioni) per verificare i tempi necessari per romperle.
	</p>
	<p>
		Alla fine abbiamo selezionato curve che abbiamo rotto in pochi secondi,
		pochi minuti, poche ore e una brutta curva che nonostante fosse definita
		su un campo primo di soli 75 bit, ha impiegato quasi 3 giorni per essere rotta.
	</p>
	<p>
		Inoltre abbiamo aggiunto una curva anomala, presa da <a href="http://safecurves.cr.yp.to/">
			safecurves.cr.yp.to, </a> per aumentare la consapevolezza su questa vulnerabilità. Consigliamo
		vivamente di controllare il sito Web per saperne di più sulla sicurezza delle curve in ECC.
	</p>
</div>
<hr>
<div id="feedback">
	<h3> Feedback </h3>
	<hr>
	<p> Dopo il concorso porremo ai partecipanti le seguenti domande: </p>
	<ul><em>
			<li> Sei uno studente?</li>
			<li> Da dove vieni?</li>
			<li> Hai implementato qualche algoritmo per partecipare? In quale linguaggio?
				Quali algoritmi hai implementato?</li>
			<li> Hai utilizzato alcuni strumenti esistenti? Quali?</li>
			<li> Avevi accesso a un cluster o utilizzavi solo desktop/laptop personali?</li>
			<li> Hai imparato qualcosa di nuovo riguardo a ECC?</li>
		</em></ul>
	<p>Riportiamo di seguito le risposte dei partecipanti.</p>
	<hr>
	<h5>Crypto Terroni Team (primi classificati)</h5>
	<p>
		Invece di rispondere direttamente alle domande proposte, abbiamo deciso di raccontarvi
		la nostra storia. In questo modo speriamo di trasmettere insieme alle informazioni richieste
		le nostre sensazioni durante l'intera competizione, dal momento in cui ne abbiamo sentito
		l'avviso fino alla fine.
		<br><br>
		Lunedì mattina Abate e Cotardo hanno ricevuto una telefonata da Vitto: "Ragazzi del secondo anno
		(studiamo Crittografia e Teoria dei Codifiche a Trento) mi hanno parlato di un concorso di
		crittografia. Mi hanno suggerito di partecipare per gioco. Ma non ne ho idea cosa sono le
		curve ellittiche". Così ci siamo incontrati e abbiamo iniziato a cercare alcune note sulle
		curve ellittiche. Il nostro primo tentativo di violare le chiavi di esempio è stato sviluppare
		uno script magma per un attacco di forza bruta. Sebbene sapessimo che non era efficiente,
		abbiamo iniziato a occuparci delle strutture di gruppo delle curve ellittiche su un campo
		finito. Ovviamente non abbiamo avuto successo con questo approccio e abbiamo iniziato a
		studiare l'algoritmo baby-step a passo gigante. Abbiamo trovato un'implementazione Python
		di questo e sul nostro laptop ha funzionato per le chiavi di esempio. Così abbiamo iniziato
		ad applicare quell'algoritmo alle chiavi del contest. Sebbene sia un buon algoritmo, G-s B-s
		ha bisogno di molta RAM e il calcolo ha iniziato a essere irrealizzabile. Quindi abbiamo
		studiato l'algoritmo Rho di Pollard che richiede una quantità costante di memoria e abbiamo
		trovato un'implementazione Python di questo. Abbiamo rotto con queste 4 chiavi dell'algoritmo
		ma la loro implementazione non è stata così efficiente e ha funzionato bene solo per curve "minuscole".
		<br><br>
		Abbiamo capito che la chiave era la potenza di calcolo (a questo punto avevamo solo 3 giorni rimasti)
		e abbiamo iniziato a implementare uno script Magma in cui viene calcolato un logaritmo discreto
		(Magma utilizza una versione molto efficiente dell'algoritmo rho di Pollard). L'abbiamo eseguito
		su una macchina virtuale Microsoft Azure con 20 CPU &#64; 2,5 Ghz con 60 GB di RAM e abbiamo rotto
		15 chiavi aggiuntive in 2 giorni. La diciannovesima chiave è stata l'ultima rimasta intatta: ci serviva un'idea.
		<br><br>
		Giovedì mattina, durante la ricerca dell'algoritmo probabilistico, dell'accelerazione dell'algoritmo
		di Pollard-rho e così via, Vitto ha notato che l'ordine della curva era la caratteristica del
		campo, ma non sapevamo come utilizzare questa informazione. Quella sera Vitto ha rotto l'ultima
		chiave: ha appena scoperto che la curva appartiene alla famiglia delle "Curve Ellittiche Anomale"
		per cui il sollevamento della curva sul campo p-adico riduce il problema ECDLP originale al
		problema DLP sul gruppo additivo di ordine p (che ha costo polinomiale); con uno script Sage
		eseguito su un server cloud Sage le ultime chiavi sono state calcolate istantaneamente!
		<br><br>
		Tutti i membri del team concordano sul fatto che questo concorso è stato molto formativo:
		abbiamo imparato non solo l'algebra e gli algoritmi che potrebbero essere inutili senza una
		buona base teorica, ma abbiamo anche capito l'importanza del lavoro di squadra, dove idee e
		approcci diversi erano la chiave per vincere questa competizione.
		<br><br>
		CryptoTerroni Team - Giuseppe Vitto, Carmine Abate, Giuseppe Cotardo"
		<br><br>
		PS: Siamo tutti del sud Italia: Bari, Lecce, Salerno. Per questo motivo ci chiamiamo
		con orgoglio CryptoTerroni: Terroni è il modo in cui le persone del nord Italia chiamano le persone del sud.
	</p>
	<hr>
	<h5>Luca Chiodini (secondo classificato)</h5>
	<ul>
		<li>
			<em>Sei uno studente?</em>
			<p>Sì, sto studiando informatica all'Università degli Studi di Milano - Bicocca.</p>
		</li>
		<li>
			<em>Da dove vieni?</em>
			<p> Vivo vicino a Bergamo.</p>
		</li>
		<li>
			<em> Hai implementato qualche algoritmo per partecipare? In quale linguaggio?
				Quali algoritmi hai implementato?</em>
			<p> Ho scritto uno script in SageMath per eseguire i calcoli di base (ad esempio,
				per calcolare l'ordine di un punto nella data curva ellittica).
			</p>
		</li>
		<li>
			<em>Hai utilizzato alcuni strumenti esistenti? Quali?</em>
			<p>Ho usato la piattaforma cloud di SageMath e il solutore ECDLP, che a sua volta
				utilizza una versione dell'algoritmo Pollard Rho per rompere le chiavi.</p>
		</li>
		<li>
			<em>Avevi accesso a un cluster o utilizzavi solo desktop/laptop personali?</em>
			<p>Ho usato solo il mio computer desktop.</p>
		</li>
		<li>
			<em>Hai imparato qualcosa di nuovo riguardo a ECC?</em>
			<p> Ho appreso tutti i dettagli dell'ECC solo per questo concorso.</p>
		</li>
	</ul>
	<hr>
	<h5>Lorenzo Cameroni (terzo classificato)</h5>
	<ul>
		<li>
			<em>Sei uno studente?</em>
			<p>Sono uno studente di matematica di 27 anni. </p>
		</li>
		<li>
			<em>Da dove vieni?</em>
			<p>Studio a Milano, ma sono di Quarona (VC). </p>
		</li>
		<li>
			<em> Hai implementato qualche algoritmo per partecipare? In quale linguaggio?
				Quali algoritmi hai implementato?</em>
			<p>
				Sì, ho provato a codificare (con PARI/GP) un attacco alla curva 19 che è anomalo
				(cioè il numero di punti razionali di <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;E" /> su <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;\mathbb{F}_p" /> è <img src="https://latex.codecogs.com/gif.latex?\
				large&amp;space;p" />), ma il mio codice non ha
				funzionato come previsto (beh, ora funziona , ma ora è troppo tardi); i dettagli
				dell'algoritmo che ho codificato sono in Silverman, "The Arithmetic of Elliptic Curves",
				pagine 389-390. Non ho provato a codificare l'algoritmo rho di Pollard perché sapevo
				che la funzione elllog PARI/GP utilizzava già questo algoritmo. Non ho provato a
				codificare l'algoritmo passo-passo Baby-step perché ha bisogno di troppa memoria.
			</p>
		</li>
		<li>
			<em>Hai utilizzato alcuni strumenti esistenti? Quali?</em>
			<p> Sì, la funzione elllog PARI/GP e altre funzioni relative alle curve ellittiche in PARI/GP.</p>
		</li>
		<li>
			<em>Avevi accesso a un cluster o utilizzavi solo desktop/laptop personali?</em>
			<p> Ho utilizzato solo il mio laptop.</p>
		</li>
		<li>
			<em>Hai imparato qualcosa di nuovo riguardo a ECC?</em>
			<p> Sì certo: ho imparato a conoscere le curve supersingolari (ma non c'erano in gara),
				le curve anomale e ho imparato l'algoritmo del baby-step giant-step
				(anche se non ho provato ad implementarlo).</p>
		</li>
	</ul>
	<hr>
	<h5>Alessandro De Piccoli (terzo classificato)</h5>
	<ul>
		<li>
			<em>Sei uno studente?</em>
			<p>Sì.</p>
		</li>
		<li>
			<em>Da dove vieni?</em>
			<p> Sono di Varedo (MB).</p>
		</li>
		<li>
			<em> Hai implementato qualche algoritmo per partecipare? In quale linguaggio?
				Quali algoritmi hai implementato?</em>
			<p> Ho codificato baby-step giant-step e pollard rho usando pari/gp.
				Il primo era semplice ma era costoso in termini di memoria, quindi ho
				pensato di archiviare i risultati in un file .txt ma alla dimensione
				di 300 Mb ho interrotto il processo. Ho codificato pollard rho ma
				quando ho scoperto che pari usa pollard rho per chiavi di grandi
				dimensioni ho deciso di usare direttamente la funzione pari.</p>
		</li>
		<li>
			<em>Hai utilizzato alcuni strumenti esistenti? Quali?</em>
			<p>Sì, ho usato il software pari/gp.</p>
		</li>
		<li>
			<em>Avevi accesso a un cluster o utilizzavi solo desktop/laptop personali?</em>
			<p>Ho usato solo i miei personal computer, ma io e il mio amico abbiamo notato che
				ci sono differenze importanti. Ad esempio, con il mio computer, io ero più
				veloce di un'ora in un tempo totale di 4 ore, ma lui era più veloce di 50
				secondi in un tempo totale di un minuto.</p>
		</li>
		<li>
			<em>Hai imparato qualcosa di nuovo riguardo a ECC?</em>
			<p>In generale, ho rivisto le mie conoscenze sull'ECC. Ho studiato nuovi algoritmi come
				baby-step giant-step e pollard rho per DLP. Questi algoritmi mi erano sconosciuti.
				Ho scoperto l'attacco MOV che era inutile in gara. Ho provato anche a studiare un
				articolo di hp che usa l'alzata dei punti in <img src="https://latex.codecogs.com/gif.latex?\
					large&amp;space;E(Qp)" /> e il mio amico mi ha detto
				che il suggerimento di Silverman era di usare <img src="https://latex.codecogs.com/gif.latex?\
					large&amp;space;E(\mathbb{Z}_{p^2})" /> con un'altra forma dell'equazione
				della curva e così abbiamo provato in questo modo.</p>
		</li>
	</ul>
	<hr>
	<h5>Carlo Brunetta (Anomalous Marty with Deloran, quarto classificato) </h5>
	<ul>
		<li>
			<em>Sei uno studente?</em>
			<p>Sì.</p>
		</li>
		<li>
			<em>Da dove vieni?</em>
			<p> Trento.</p>
		</li>
		<li>
			<em> Hai implementato qualche algoritmo per partecipare? In quale linguaggio?
				Quali algoritmi hai implementato?</em>
			<p> Solo un po' di codice per rendere più facile il calcolo algebrico.
				È stato scritto in Python/Sage. L'algoritmo è un attacco particolare su
				una famiglia speciale di curve deboli.</p>
		</li>
		<li>
			<em>Hai utilizzato alcuni strumenti esistenti? Quali?</em>
			<p>Carta e penna e un Delorean DMC-12 con un condensatore di flusso
				per inviare la risposta nel 1985.</p>
		</li>
		<li>
			<em>Avevi accesso a un cluster o utilizzavi solo desktop/laptop personali?</em>
			<p>Bastano 0 secondi del portatile e alcuni giorni sulla carta per
				capire perché funziona.</p>
		</li>
		<li>
			<em>Hai imparato qualcosa di nuovo riguardo a ECC?</em>
			<p> Si, direi molte.</p>
		</li>
	</ul>
	<hr>
</div>